
        var result = require("!!../../../../node_modules/css-loader/index.js!./about.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/about/about.component.css
// module id = 344
// module chunks = 0